import { Component, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { NavigationEnd, Router } from '@angular/router';
import { UserService } from '../../../services/user.service';
import { MenuItems, NavigationData } from '../../../core/model/constants/nav-data';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { SharedService } from '../../../services/shared.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-side-nav',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './side-nav.component.html'
})
export class SideNavComponent implements OnInit {

  constructor(
    private router: Router,
    private userService: UserService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private sharedService: SharedService,
  ) {
    this.matIconRegistry.addSvgIcon("cherry", this.domSanitizer.bypassSecurityTrustResourceUrl("../../../../assets/icons/cherry.svg"))
  }

  @Output() isCollapsed = new EventEmitter<any>();
  activeRoute: string = '';
  navigationItems = NavigationData;
  menuItems: any[] = MenuItems;
  isExpanded: boolean;
  isShowMobile: boolean;
  isCompactMode: boolean;
  subscription: Subscription;
  @ViewChild('scrollContainer', { static: false, read: ElementRef }) private scrollContainer!: ElementRef<HTMLElement>;

  @HostListener('window:resize', [])
  onResize() {
    this.checkHeight();
  }

  ngOnInit() {
    this.onResize();
    this.checkRoute();
    this.getMobileSidenav();
  }

  isActive(route: string): boolean {
    return this.activeRoute.includes(route);
  }

  private checkHeight() {
    this.isCompactMode = window.innerHeight < 500;
  }


  checkRoute() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.activeRoute = event.url;
        const activeItem = this.navigationItems.find(item => item.route === this.activeRoute);
        if (activeItem) {
          this.userService.setNavigationItems([activeItem]);
        }
      }
    });
  }

  toggleSidenav() {
    this.isExpanded = !this.isExpanded;
    this.isCollapsed.emit(this.isExpanded);
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 0);
  }

  getMobileSidenav() {
    this.subscription = this.sharedService.togglePhoneSidenav.subscribe((res: any) => {
      this.isExpanded = true
      this.isShowMobile = res;
    })
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  handleSidenavCollapse(clickedEl?: any) {
    if (!this.isShowMobile) {
      this.isExpanded = false;         // collapse UI
      this.isCollapsed.emit(this.isExpanded);  // emit to parent if needed
    }
    
    setTimeout(() => {
      const container = this.scrollContainer?.nativeElement;
      if (!container || !clickedEl) return;

      const elTop = clickedEl.offsetTop;
      const containerMid = container.scrollHeight / 2;

      if (elTop > containerMid) {
        // agar clicked element neeche half me hai → pura neeche scroll
        container.scrollTo({ top: container.scrollHeight, behavior: 'smooth' });
      } else {
        // agar clicked element upar half me hai → pura top scroll
        container.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }, 50);
  }
}
